var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('p',[_vm._v("SCORE: "+_vm._s(_vm.score))]),_c('canvas',{attrs:{"width":"400","height":"400","id":"canvas_"}}),_c('button',{ref:"startButton",on:{"click":this.init}},[_vm._v("START")])])}
var staticRenderFns = []

export { render, staticRenderFns }